module.exports = __webpack_public_path__ + "static/media/kfol.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/kfol.png
// module id = 1303
// module chunks = 3